import { LiquidString } from "../common/LiquidString.js";
import * as $ from 'jquery';

class RuntimeComponent {
    id = 0;
    version = 0;
    hasRuntimeView = true;
    nextButtonEnabled = true;
    eventBroker;

    constructor(identifyer, version) {
        this.id = identifyer;
        this.version = version;
    }

    values = {
        buttontext: { value: "Next" }
    };

    params = {};

    getNextButtonText() {
        if (this.values.buttontext && this.values.buttontext.value)
            return this.values.buttontext.value;
        else
            return "";
    }

    enableNextButton() {
        this.nextButtonEnabled = true;
        if (this.eventBroker)
            this.eventBroker.fire("enableNextButtonEvent", this.id);
    }

    disableNextButton() {
        this.nextButtonEnabled = false;
        if (this.eventBroker)
            this.eventBroker.fire("disableNextButtonEvent", this.id);
    }

    getLangTexts() {
        return this.values;
    }

    setLangTexts(language) {
        for (var languageIndex in language) {
            var langtext = language[languageIndex];
            if (this.values[languageIndex] instanceof LiquidString) {
                this.values[languageIndex].updateText(langtext);
            } else if (typeof this.values[languageIndex] === 'object' && typeof langtext === 'object') {
                this.values[languageIndex].value = langtext.value;
            }
        }
    }

    importModel(model) {
        if (model.values) {
            for (var i in model.values) {
                let existingvalue = this.values[i];
                let imputvalue = model.values[i];

                if (existingvalue instanceof LiquidString) {
                    this.values[i].updateText(imputvalue);
                } else {
                    if (this.values[i] && this.values[i].value)
                        this.values[i].value = imputvalue.value;
                }
            }
        }

        if (model.params && !$.isEmptyObject(model.params))
            this.params = model.params;
    };

    hookupLiquidTexts() {
        for (var i in this.values) {
            if (this.values[i] instanceof LiquidString) {
                this.values[i].eventBroker = this.eventBroker;
            }
        }

        this.eventBroker.subscribe("valueChangedEvent", this.onRuntimeChanged.bind(this));
    }

    onRuntimeChanged(eventParams) {
        if (eventParams.id == this.id)
            return;

        for (var i in this.values) {
            if (this.values[i] instanceof LiquidString) {
                this.values[i].setEdit(eventParams.key, eventParams.value);
            }
        }
    }

    output = [];
}

export { RuntimeComponent }